import {
  ApolloClient,
  split,
  InMemoryCache,
  HttpLink,
  ApolloLink,
} from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities/index.js";
import { onError } from "@apollo/client/link/error/index.js";
import csrf from "@/lib/csrf.js";
import { captureMessage } from "@sentry/vue";
import fetch from "unfetch";

import { createConsumer } from "@rails/actioncable";
import ActionCableLink from "graphql-ruby-client/subscriptions/ActionCableLink.js";

// Setup a link for action cable
const cable = createConsumer("/subscribe");
const actionCableLink = new ActionCableLink({ cable });

const httpLink = new HttpLink({
  uri: "/graphql",
  fetch: fetch,
  headers: {
    "GraphQL-Visibility": "internal",
    [csrf.headerKey]: csrf.token,
  },
});

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((err) => {
      const message = err.message;

      const errorMessagePatterns = [
        /Variable .* was provided invalid value for .*/,
        /Fragment .* can't be spread inside .*/,
        /Fragment .* was defined, but not used.*/,
      ];

      for (const pattern of errorMessagePatterns) {
        if (pattern.test(message)) {
          captureMessage(`Invalid GraphQL query: ${message}`, "error");
          break;
        }
      }
    });
  }
});

// Redirect subscriptions to the action cable link, while using the HTTP link for other queries
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);

    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  actionCableLink,
  httpLink,
);

const link = ApolloLink.from([errorLink, splitLink]);

const clientOptions = {
  link,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: "no-cache",
    },
  },
};

export const gqlClient = new ApolloClient(clientOptions);
